export const ValueSign = ({
  value,
  showPositiveSign,
}: {
  value: number;
  showPositiveSign: boolean;
}) => {
  return value > 0 ? (showPositiveSign ? '+ ' : '') : value < 0 ? '- ' : '';
};
